/* fmnv: Fotos der Konfigurator-PDP im Vollbild mit Zoom (2026-10-08, Marc).
   Vor allem mobil: Antippen des großen Fotos (oder der Lupe) öffnet alle Fotos der
   Kachelleiste in PhotoSwipe — Pinch-Zoom, Doppeltipp, Wischen. Das 3D-Modell
   bleibt außen vor, es zoomt selbst.
   Bewusst eigene Datei: fmnv-p3d-main.js wird parallel bearbeitet. Gelesen wird nur
   das DOM, das main.js ohnehin erzeugt ([data-p3d-foto], [data-p3d-fotokachel]).
   PhotoSwipe (liegt dem Edge-Theme bei) wird erst beim ersten Öffnen geladen. */
(function () {
  const self = document.currentScript;
  const PSWP_JS = self && self.dataset.pswpJs;
  const PSWP_CSS = self && self.dataset.pswpCss;
  // Shopify liefert maximal das Original aus; größer anfragen kostet nichts.
  const GROSS = 2400;

  let laden = null;
  function ladePhotoSwipe() {
    if (window.PhotoSwipe) return Promise.resolve();
    if (laden) return laden;
    laden = new Promise((resolve, reject) => {
      if (PSWP_CSS) {
        const l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = PSWP_CSS;
        document.head.appendChild(l);
      }
      const s = document.createElement('script');
      s.src = PSWP_JS;
      s.onload = () => resolve();
      s.onerror = () => { laden = null; reject(new Error('PhotoSwipe nicht geladen')); };
      document.head.appendChild(s);
    });
    return laden;
  }

  const basis = (u) => (u || '').split('?')[0].replace(/^https?:/, '');
  const mitBreite = (u, w) => (/[?&]width=\d+/.test(u) ? u.replace(/width=\d+/, 'width=' + w)
    : u + (u.includes('?') ? '&' : '?') + 'width=' + w);

  // Seitenverhältnis aus der (meist schon geladenen) Kachel-Datei.
  function verhaeltnis(src) {
    return new Promise((resolve) => {
      const i = new Image();
      i.onload = () => resolve(i.naturalWidth ? i.naturalHeight / i.naturalWidth : 1);
      i.onerror = () => resolve(1);
      i.src = src;
    });
  }

  async function oeffne(root, fotoEl) {
    const kacheln = [...root.querySelectorAll('[data-p3d-thumbs] [data-p3d-fotokachel]:not(.fmnv-p3d__thumb--video)')];
    let items = kacheln.map((b) => {
      const m = (b.style.backgroundImage || '').match(/url\(["']?(.*?)["']?\)/);
      return m ? { klein: m[1], alt: b.getAttribute('aria-label') || '' } : null;
    }).filter(Boolean);
    // Fallback: keine Kacheln lesbar — wenigstens das gezeigte Foto.
    if (!items.length) items = [{ klein: fotoEl.currentSrc || fotoEl.src, alt: fotoEl.alt }];

    let index = items.findIndex((it) => basis(it.klein) === basis(fotoEl.currentSrc || fotoEl.src));
    if (index < 0) {
      items.unshift({ klein: fotoEl.currentSrc || fotoEl.src, alt: fotoEl.alt });
      index = 0;
    }

    const [, ratios] = await Promise.all([
      ladePhotoSwipe(),
      Promise.all(items.map((it, n) => (n === index && fotoEl.naturalWidth
        ? fotoEl.naturalHeight / fotoEl.naturalWidth
        : verhaeltnis(it.klein)))),
    ]);

    const dataSource = items.map((it, n) => ({
      src: mitBreite(it.klein, GROSS),
      width: GROSS,
      height: Math.round(GROSS * ratios[n]),
      alt: it.alt,
      msrc: it.klein,
    }));

    /* Icons wie in Edges lightbox.js: photoswipe.css zeichnet Knopf-SVGs nur als Kontur
       (fill:none; stroke:currentColor) und spiegelt den Pfeil für „weiter“ selbst. Die
       gefüllten Standard-Icons von PhotoSwipe werden so zu Doppelwinkeln und schiefem X. */
    const PFEIL = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="2"></path></svg>';
    const KREUZ = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path></svg>';

    const pswp = new window.PhotoSwipe({
      arrowPrevSVG: PFEIL,
      arrowNextSVG: PFEIL,
      closeSVG: KREUZ,
      dataSource,
      index,
      bgOpacity: 1,
      loop: dataSource.length > 1,
      counter: dataSource.length > 1,
      wheelToZoom: true,
      // Der Zoom-Knopf hat im Edge-photoswipe.css keinen Stil (sitzt winzig unten rechts);
      // Zoomen geht per Pinch, Doppeltipp, Klick und Mausrad.
      zoom: false,
      showHideAnimationType: 'fade',
      closeTitle: 'Schließen',
      zoomTitle: 'Zoomen',
      arrowPrevTitle: 'Vorheriges Bild',
      arrowNextTitle: 'Nächstes Bild',
      errorMsg: 'Das Bild konnte nicht geladen werden.',
    });
    pswp.init();
  }

  function styles() {
    if (document.getElementById('fmnv-p3d-bildzoom-css')) return;
    const st = document.createElement('style');
    st.id = 'fmnv-p3d-bildzoom-css';
    // px statt rem: Die Theme-Wurzelschrift liegt bei ~9,4px.
    st.textContent = `
      [data-p3d-foto]:not([hidden]){cursor:zoom-in}
      /* Unten links: oben rechts sitzt das Favoriten-Herz, unten rechts die Stoffkarte. */
      .fmnv-p3d__bildzoom{position:absolute;left:14px;bottom:14px;z-index:5;width:44px;height:44px;border-radius:50%;
        border:0;background:rgba(255,255,255,.92);color:#2B2B2B;display:grid;place-items:center;cursor:pointer;
        box-shadow:0 2px 10px rgba(0,0,0,.12);transition:transform .15s}
      .fmnv-p3d__bildzoom:hover{transform:scale(1.06)}
      .fmnv-p3d__bildzoom:focus-visible{outline:3px solid #FF6542;outline-offset:2px}
      .fmnv-p3d__bildzoom[hidden]{display:none}
      @media (max-width:749px){.fmnv-p3d__bildzoom{left:10px;bottom:10px;width:40px;height:40px}}`;
    document.head.appendChild(st);
  }

  function richteEin(root) {
    const fotoEl = root.querySelector('[data-p3d-foto]');
    if (!fotoEl || fotoEl.dataset.fmnvZoom) return;
    fotoEl.dataset.fmnvZoom = '1';
    styles();
    if (getComputedStyle(fotoEl.parentElement).position === 'static') fotoEl.parentElement.style.position = 'relative';

    const knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'fmnv-p3d__bildzoom';
    knopf.setAttribute('aria-label', 'Bild vergrößern');
    knopf.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5M11 8v6M8 11h6"/></svg>';
    fotoEl.insertAdjacentElement('afterend', knopf);

    // Lupe nur, solange ein Foto im Bild steht (main.js schaltet fotoEl.hidden).
    const sync = () => { knopf.hidden = fotoEl.hidden || !fotoEl.getAttribute('src'); };
    new MutationObserver(sync).observe(fotoEl, { attributes: true, attributeFilter: ['hidden', 'src'] });
    sync();

    const auf = (e) => {
      if (fotoEl.hidden) return;
      e.preventDefault();
      oeffne(root, fotoEl).catch(() => {});
    };
    fotoEl.addEventListener('click', auf);
    knopf.addEventListener('click', auf);
  }

  const start = () => document.querySelectorAll('.fmnv-p3d__viewer-main').forEach((v) => richteEin(v.closest('section, .shopify-section') || document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
